import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faHouse, faUserPlus, faUsers } from '@fortawesome/free-solid-svg-icons';
import { Link,  useLocation } from 'react-router-dom';
import '../../css/Navbar.css'
 import { CheckListIcon, File02Icon, GridViewIcon } from "hugeicons-react";
const Navbar = () => {
    const location = useLocation();
    const isActive =(path) => location.pathname === path;
  return (
    <>
     <div className="horizontal-layout horizontal-menu  navbar-floating footer-static  " data-open="hover" data-menu="horizontal-menu" data-col="">
     <div className="content-overlay"></div>
    <div className="header-navbar-shadow"></div>
      <div className="horizontal-menu-wrapper">
        <div className="header-navbar navbar-expand-sm navbar navbar-horizontal floating-nav navbar-light navbar-shadow menu-border container-fluid" role="navigation" data-menu="menu-wrapper" data-menu-type="floating-nav">
            <div className="navbar-header">
                <ul className="nav navbar-nav flex-row">
                    <li className="nav-item me-auto"><Link className="navbar-brand" to="/admin-dashboard"><span className="brand-logo">
                               
                                </span>
                            <h2 className="brand-text mb-0">Vuexy</h2>
                        </Link></li>
                    <li className="nav-item nav-toggle"><Link className="nav-link modern-nav-toggle pe-0" data-bs-toggle="collapse"><i className="d-block d-xl-none text-primary toggle-icon font-medium-4" data-feather="x"></i></Link></li>
                </ul>
            </div>
            <div className="shadow-bottom"></div>
            <div className="navbar-container main-menu-content bg-dark" data-menu="menu-container">
                <ul className="nav navbar-nav" id="main-menu-navigation" data-menu="menu-navigation">
                    <li className={`nav-item  ${isActive('/admin-dashboard') ? "active" :""}`}>
                     <Link   to="/admin-dashboard"   className="text-white" >
                     <GridViewIcon className='fw-bold' size={20}     />
                       Dashboard
                     </Link>
                    </li>

                    <li className={`nav-item   ${isActive('/registered-users') ? "active" :""}`}>
                    <Link   to="/registered-users"   className="text-white" >
                     <FontAwesomeIcon icon={faUsers} />
                       Registered Users
                     </Link>
                    </li>
                      <li className={`nav-item  ${isActive('/add-user') ? "active" :""}`}>
                    <Link   to="/add-user"   className="text-white" >
                     <FontAwesomeIcon icon={faUserPlus} />
                       Add User
                     </Link>
                    </li>
                     <li className={`nav-item  ${isActive('/sessions') ? "active" :""}`}>
                    <Link   to="/sessions"   className="text-white" >
                     <FontAwesomeIcon icon={faEye} />
                       Sessions
                     </Link>
                    </li>
                
                </ul>
            </div>
        </div>
    </div>
    </div>
    </>
  )
}

export default Navbar